import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LockedList } from './non-compliance-list';
import { trigger, style, animate, transition } from '@angular/animations';
import { NonComplianceListService } from './non-compliance-list.service';
import { MatSnackBar } from '@angular/material';
import { SessionStorage } from 'ngx-webstorage';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';

@Component({
  selector: 'app-non-compliance-list',
  templateUrl: './non-compliance-list.component.html',
  styleUrls: ['./non-compliance-list.component.css'],
  animations: [
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms ease-in', style({ opacity: 1 }))
      ]),
    ]
    )
  ]
})

export class NonComplianceListComponent implements OnInit {
  @SessionStorage() public user;
  @SessionStorage() public config;

  public nonComplianceList: LockedList[] = [];
  public nonAdherenceList: LockedList[] = [];
  public totalElements = 0;
  public employeeSearch = '';
  public pageAdherenceNumber = 1;
  public pageComplianceNumber = 1;
  public isComplainceSearch = false;
  public pagecount = 1;

  constructor(
    private nonComplianceListService: NonComplianceListService,
    private snackBar: MatSnackBar,
    private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.getNonAdherence();
  }

  /*Function to get non compliance employee list*/
  getNonCompliance() {
    this.nonComplianceList = [];
    this.spinnerService.show();
    this.nonComplianceListService.getNonComplianceList().subscribe((response) => {
      this.spinnerService.hide();
      this.totalElements = response.payload.length;
      if (response.payload && response.payload.length > 0) {
        response.payload.map(value => {
          this.nonComplianceList.push(new LockedList(value, 'nonCompliance'));
        });
      }
    },
      (error) => {
        this.spinnerService.hide();
        this.snackBar.open('Error in fetching locked list', 'Okay', {
          duration: 3000,
        });
      }
    );
  }

  /*Function to get non adherence employee list*/
  getNonAdherence() {
    this.nonAdherenceList = [];
    this.spinnerService.show();
    this.nonComplianceListService.getNonAdherenceList().subscribe((response) => {
      this.spinnerService.hide();
      this.totalElements = response.payload.length;
      if (response.payload.lockedEmplist) {
        response.payload.lockedEmplist.map(value => {
          this.nonAdherenceList.push(new LockedList(value, 'nonAdherence'));
        });
      }
    },
      (error) => {
        this.spinnerService.hide();
        this.snackBar.open('Error in fetching locked list', 'Okay', {
          duration: 3000,
        });
      });
  }

  /*Function to unlock adherence employee*/
  unlockAdherenceSelected(empId) {
    const employees = [];
    employees.push(empId);
    if (employees.length > 0) {
      this.nonComplianceListService.unlockNonAdherence(employees).subscribe((response) => {
        this.snackBar.open('Unlocked selected employees Successfully', 'Okay', {
          duration: 3000,
        });
        this.getNonAdherence();
      }, (error) => {
        this.snackBar.open('Error occured while unlocking the timesheet', '', {
          duration: 3000
        });
      });
    }
  }

  /*Function to unlock compliance employee*/
  unlockComplianceSelected(empId) {
    const employees = [];
    employees.push(empId);
    if (employees.length > 0) {
      this.nonComplianceListService.unlockNonCompliance(employees).subscribe((response) => {
        this.snackBar.open('Unlocked selected employees Successfully', 'Okay', {
          duration: 3000,
        });
        this.getNonCompliance();
      }, (error) => {
        this.snackBar.open('Error occured while unlocking the timesheet', '', {
          duration: 3000
        });
      });
    }
  }

  /*Function to switch locked list*/
  switchLockedList(tab) {
    if (tab.index === 0) {
      this.pageAdherenceNumber = 1;
      this.employeeSearch = '';
      this.isComplainceSearch = false;
      this.getNonAdherence();
    } else if (tab.index === 1) {
      this.pageComplianceNumber = 1;
      this.employeeSearch = '';
      this.isComplainceSearch = true;
      this.getNonCompliance();
    }
  }

  /**
* @function checkSearchData()
* @description
* check search data is empty and display all data
* @author Abhiraj
*/
  checkSearchData() {
    if (!this.employeeSearch) {
      this.pageAdherenceNumber = 1;
      this.pageComplianceNumber = 1;
      if (!!this.isComplainceSearch) {
        this.getNonCompliance();
      } else {
        this.getNonAdherence();
      }
    }
  }

  /* Search for Locked request based on Employee name */
  applySearch(pagecount) {
    if (!!this.employeeSearch) {
      this.spinnerService.show();
      this.nonComplianceListService.searchEmployee(
        this.employeeSearch.trim(), this.isComplainceSearch, pagecount).subscribe((response) => {
          this.spinnerService.hide();
          this.totalElements = response.payload.totalCount;
          this.nonComplianceList = [];
          this.nonAdherenceList = [];
          response.payload.lockedList.forEach(value => {
            if (!!this.isComplainceSearch) {
              this.nonComplianceList.push(new LockedList(value, 'nonCompliance'));
            } else {
              this.nonAdherenceList.push(new LockedList(value, 'nonAdherence'));
            }
          });
        },
          (error) => {
            this.spinnerService.hide();
          });
    } else {
      if (!!this.isComplainceSearch) {
        this.getNonCompliance();
      } else {
        this.getNonAdherence();
      }
    }
  }

  /* Upon change of pagination call API again */
  triggerComplianceChange(data: any) {
    this.pageComplianceNumber = data;
    if (this.employeeSearch) {
      this.applySearch(data);
    } else {
      this.getNonCompliance();
    }
  }

  /* Upon change of pagination call API again */
  triggerAdherenceChange(data: any) {
    this.pageAdherenceNumber = data;
    if (this.employeeSearch) {
      this.applySearch(data);
    } else {
      this.getNonAdherence();
    }
  }

/**
* @function exportCSV()
* @description
* Function to export Non Compliance list of employee
* @author Arul @Date 09/04/2020
*/
  exportCSV() {
    const fileNameRandom = moment().format("MM/DD/YYYY HH:mm:ss");
    const fileName = "Non Complaince_" + fileNameRandom;
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: true,
      title: "Non Complaince list : " + "Date:" + fileNameRandom,
      useBom: true,
      headers: ["Employee Name", "Employee Id", "Reporting Manager", "Locked Date", "Since No.of Days"],
    };
    // console.log(this.nonComplianceList);
    if (this.nonComplianceList.length > 0) {
      // console.log(this.nonComplianceList);
      let exportObject = [];
      for (let i = 0; i < this.nonComplianceList.length; i++) {
        exportObject.push({
          "Employee Name": this.nonComplianceList[i].employeeName,
          "Employee Id": this.nonComplianceList[i].employeeId,
          // "Reason": this.nonComplianceList[i].reason,
          "Reporting Manager": this.nonComplianceList[i].reportingManger,
          "Locked Date": this.nonComplianceList[i].fromDate,
          "Since No.of Days": this.nonComplianceList[i].days,
        })
      }
      new Angular2Csv(exportObject, fileName, options);
    }
    else {
      this.snackBar.open('No data to export', 'OK', {
        duration: 3000
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/non-compliance-list/non-compliance-list.component.ts